import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();
  const skipRef = useRef(false);
  skipRef.current = Boolean(location.hash || (location.state && location.state.scrollTo));

  useEffect(() => {
    if (skipRef.current) return;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
